import './application.css'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from '../App.vue'
import router from '../router'

// A lazy page failed to load (stale chunk after a rebuild): reload once instead of showing a blank page.
window.addEventListener('vite:preloadError', (e) => { e.preventDefault(); window.location.reload() })

const app = createApp(App)
app.config.errorHandler = (err) => {
  console.error(err)
  document.getElementById('app-error')?.remove()
  const box = document.createElement('div')
  box.id = 'app-error'
  box.className = 'fixed bottom-4 left-4 right-4 bg-red-50 border border-red-300 text-red-800 rounded-lg p-3 text-sm z-50'
  box.textContent = 'Что-то пошло не так. Обнови страницу, если она не отвечает.'
  document.body.appendChild(box)
}
app.use(createPinia()).use(router).mount('#app')
